import React from 'react';
import { View, Text, Platform } from 'react-native';
import { XStack } from 'tamagui';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import styles from '@stylesheet';
import { getModernCardStyle, getModernActionStyle, getModernTextColor } from '@stylesheet';
import type { UIComponentContract } from '../../types/componentContract';

export const uiContract: UIComponentContract = {
  id: "statistics.card",
  accepts: {
    capability: "display_statistics",
    shape: {
      title: "string",
      value: "string",
      icon: "object",
      color: "string",
      subtitle: "string?",
      isLoading: "boolean?"
    },
    required: ["title", "value"],
    optional: ["icon", "color", "subtitle", "isLoading"]
  },
  renders: "card",
  priority: 10,
  surface: "dashboard"
};

interface StatCardProps {
  data: {
    title: string;
    value: string;
    icon?: React.ReactNode;
    color?: 'blue' | 'green' | 'red' | 'amber' | 'grey';
    subtitle?: string;
    isLoading?: boolean;
  };
}

export const StatCard: React.FC<StatCardProps> = ({ data }) => {
  const theme = themeSelector();
  const cardStyle = getModernCardStyle(theme);
  const textColor = getModernTextColor(theme, 'primary');
  const mutedTextColor = getModernTextColor(theme, 'secondary');
  
  const { title, value, icon, color = 'blue', subtitle, isLoading = false } = data || {};

  return (
    <View style={[styles.modernStatsCard, cardStyle, { flex: 1, marginVertical: 0, minHeight: 170, marginHorizontal: 0, marginBottom: 16 }]}>
      <XStack flexWrap="wrap" style={[styles.modernRow, { flex: 1 }]}>
        {icon && (
          <View style={[styles.modernActionButton, getModernActionStyle(theme, color), { maxWidth: 30, flexBasis: 40, maxHeight: 40, flex: 1 }]}>
            {icon}
          </View>
        )}
        <View style={{ flex: 1, flexBasis: 300, justifyContent: 'center', alignItems: 'flex-start' }}>
          <Text style={[styles.modernFieldLabel, { color: mutedTextColor, fontSize: 14, marginBottom: 4 }]}>{title}</Text>
          <Text style={[styles.modernStatsNumber, { color: textColor, fontSize: 20, textAlign: 'left', fontWeight: '600' }]}>
            {isLoading ? 'Loading...' : value}
          </Text>
          {subtitle && (
            <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 4 }}>
              <Text style={[{ fontSize: 12, color: mutedTextColor }]}>
                {subtitle}
              </Text>
            </View>
          )}
        </View>
      </XStack>
    </View>
  );
};

// Attach contract to component
(StatCard as any).uiContract = uiContract;

export default StatCard;












